import { FunctionComponent } from "react";
import styled from "styled-components";
import Image from "next/image";

import { CXL } from "@/components/Typography";
import { colours } from "@/utils";
import { Device } from "@/utils/device";

const learningCopy =
  "In a changing world, learning is the constant that future-proofs your career and ensures your success. AllBright membership offers tailored coaching, masterclasses, workshops, and resources to boost your career.";

const LearningHeader: FunctionComponent = () => {
  return (
    <S.Section>
      <S.LogoContainer>
        <Image
          src="/images/AllBrightA.png"
          alt=""
          layout="fill"
          objectFit="contain"
        />
      </S.LogoContainer>
      <S.H1>Define your ambition, secure your success</S.H1>
      <S.H2>{learningCopy}</S.H2>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  padding: 5rem 3rem;
  background-color: #104052;
  background-image: url("/images/marketing/woman-green-background.png");
  background-size: auto 100%;
  background-repeat: no-repeat;
  height: 55rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;

  @media (min-width: ${Device.mobile}) {
    padding: 5rem 5rem;
  }

  @media (min-width: ${Device.tablet}) {
    padding-left: 40vw;
  }

  @media (min-width: ${Device.desktop}) {
    padding-left: 40vw;
    padding-right: 10vw;
    background-size: 100% auto;
  }
`;

S.LogoContainer = styled.div`
  height: 6rem;
  width: 100%;
  position: relative;
  display: inline-block;
  margin-bottom: 4rem;
`;

S.H1 = styled.h1`
  font-family:
    Roxborough CF,
    sans-serif;
  font-size: 6rem;
  font-weight: 100;
  line-height: 5rem;
  letter-spacing: -1px;
  text-align: center;
  color: ${colours.shell};
  background-color: rgba(0, 0, 0, 0.5);
  margin-bottom: 4rem;
  padding: 1.5rem 0;

  @media (min-width: ${Device.tablet}) {
    background-color: rgba(0, 0, 0, 0);
  }
`;

S.H2 = styled(CXL)`
  font-weight: 400;
  text-align: center;
  color: ${colours.shell};
  padding: 0.75rem 0;
  background-color: rgba(0, 0, 0, 0.5);

  @media (min-width: ${Device.tablet}) {
    background-color: rgba(0, 0, 0, 0);
  }
`;

export default LearningHeader;
